import * as React from 'react';
import { createRoot, Root } from 'react-dom/client';
import { Provider } from 'react-redux';
import { Store } from 'redux';
import { LazyWrapper } from '../lazy/lazy_wrapper';
import { TChatGroupId } from '../../../types/rest/IRestChatGroup';
import { TChatId } from '../../../types/rest/IRestChat';

export class ChatView {
    root: Root;
    store: Store;
    groupId: TChatGroupId;
    chatId: TChatId;
    isWarn: boolean;
    chatComponent: React.LazyExoticComponent<any>;

    constructor (el: HTMLElement, store: Store, groupId: TChatGroupId, chatId: TChatId, isWarn: boolean) {
        this.root = createRoot(el!);
        this.store = store;
        this.groupId = groupId;
        this.chatId = chatId;
        this.isWarn = isWarn
        this.initLazy();
        this.render();
    }

    initLazy () {
        this.chatComponent = React.lazy(() =>
            import(/* webpackChunkName: "chatView" */ '../main/chatView/chatView/hocs/ChatViewHOC/ChatViewHOC')
                .then(module => ({default: module.ChatViewHOC}) as any)
                .catch(e => console.error(e))
        );
    }

    render () {
        this.root.render(
            <LazyWrapper>
                <Provider store={this.store}>
                    <this.chatComponent chatId={this.chatId} groupId={this.groupId} isWarn={this.isWarn} />
                </Provider>
            </LazyWrapper>
        );
    }

    remove () {
        this.root.unmount();
    }
}
